var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 62,
    viewBox: "0 0 75 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 30.6C28.877 33 32.4866 38.2 32.4866 45.6C32.4866 55.4 25.4678 62 16.4437 62C6.81807 62 0 55.2 0 45.6C0 41 0.802138 37.6 4.41176 28.4L15.04 0H31.0828L23.0615 30.6ZM65.5748 30.6C71.3903 33 75 38.2 75 45.6C75 55.4 67.9813 62 58.9572 62C49.3316 62 42.5134 55.2 42.5134 45.6C42.5134 41 43.3155 37.6 46.9251 28.4L57.5535 0H73.5963L65.5748 30.6Z",
    fill: "url(#paint0_linear_1239_891)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_891",
    x1: 72.9329,
    y1: 2.93466,
    x2: -0.31264,
    y2: 5.08403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345730"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/“2.41294b8436649649475d9623c8867169.svg";
export { ForwardRef as ReactComponent };